import { createContext } from "react";
import type { AuthWrapperCustomEvent } from "./auth-wrapper-wc";

export type CustomerDetails = {
  contact: {
    addresses: {
      addressType: string;
      city: string;
      country: string;
      postcode: string;
      state: string;
      street1: string;
      street2: string;
    }[];
    emails: string[];
    phones: {
      areaCode: string;
      countryCode: string;
      extension: string;
      number: string;
      type: string;
    }[];
  };
  creditCards: {
    cardCode: string;
    expirationDate: string;
    holderName: string;
    number: string;
    type: string;
  }[];
  dateOfBirth: string;
  firstName?: string | undefined;
  gender: string;
  loyaltyDetails: {
    accountBalance?: number;
    airline?: string;
    benefitsDetails?: string[];
    cobrandCardCodes?: string[];
    membershipID: string;
    membershipTier:
      | "MEMBER"
      | "MOSAIC_1"
      | "MOSAIC_2"
      | "MOSAIC_3"
      | "MOSAIC_4"
      | "MOSAIC_5";
    tiles?: number;
  };
  lastName?: string | undefined;
  prefix?: string | undefined;
  profileId: string;
  profileImage?: string | undefined;
  profileImageType?: string | undefined;
  travelBankDetails?:
    | {
        accountNumber: string;
        balance?:
          | {
              amount: string;
              currency: string;
            }
          | undefined;
      }
    | undefined;
};
export type AuthContext = {
  IS_B6AUTH_STORED?: boolean;
  IS_CREDIT_PROFILE_USER?: boolean;
  IS_TOKEN_STORED?: boolean;
  PROFILE?: { customerDetails: CustomerDetails } | undefined;
};
export const DEFAULT_AUTH_CONTEXT: AuthContext = {};
export const AuthContext = createContext(DEFAULT_AUTH_CONTEXT);
export const authReducer = (
  state: AuthContext,
  detail: AuthWrapperCustomEvent["detail"],
): AuthContext => {
  switch (detail.action) {
    case "IS_B6AUTH_STORED":
    case "IS_CREDIT_PROFILE_USER":
    case "PROFILE": {
      return { ...state, [detail.action]: detail.value };
    }
    case "IS_TOKEN_STORED": {
      return { ...state, [detail.action]: detail.value.stored };
    }
    case "LOGOUT_STATUS": {
      if (detail.value === "Completed") {
        return { ...state, PROFILE: undefined };
      }

      return state;
    }
    default: {
      return state;
    }
  }
};
